import type { Ref } from 'vue'
import type { ApiToken } from '../interfaces'

import { useApiTokensStore } from '../store'
import { useApiTokenDeleteApi } from '../../../api/api-tokens/delete.hook'
import { useApiTokensApi } from '../../../api/api-tokens/list.hook'

interface ModalDeleteApiTokenReturn {
  refIsOpen: ComputedRef<boolean>
  refIsLoading: Ref<boolean>
  refToken: ComputedRef<ApiToken | null>
  closeModal: () => void
  confirmDelete: () => Promise<void>
}

export const useModalDeleteApiToken = (): ModalDeleteApiTokenReturn => {
  const store = useApiTokensStore()

  const refIsLoading = ref(false)

  const refIsOpen = computed<boolean>(() => store.isModalDelete)
  const refToken = computed<ApiToken | null>(() => store.tokenToDelete)

  const closeModal = (): void => {
    store.setTokenToDelete(null)
  }

  const confirmDelete = async (): Promise<void> => {
    const token = refToken.value
    if (!token || refIsLoading.value) return

    await useApiTokenDeleteApi({
      tokenId: token.id,
      onStart: () => { refIsLoading.value = true },
      onSuccess: () => {
        closeModal()
        void useApiTokensApi()
      },
      onFinish: () => { refIsLoading.value = false },
    })
  }

  return {
    refIsOpen,
    refIsLoading,
    refToken,
    closeModal,
    confirmDelete,
  }
}
